import { Component, Input } from '@angular/core';
import { Word } from '@models/Word';
import { GlossSelectorComponent } from "../gloss-selector/gloss-selector.component";
import { ApiService } from '../../api.service';
import { CommonModule } from '@angular/common';
import { Verse } from '@models/Verse';
import { ParsingSummaryComponent } from '../parsing-summary/parsing-summary.component';
import { MatDialog } from '@angular/material/dialog';
import { SynchronizerService } from '../../synchronizer.service';

@Component({
  selector: 'app-word-display',
  templateUrl: './word-display.component.html',
  styleUrl: './word-display.component.scss',
  imports: [CommonModule, GlossSelectorComponent]
})
export class WordDisplayComponent {
  @Input() word!: Word;
  @Input() verse!: Verse;

  constructor(public api: ApiService,
    private synchronizerService: SynchronizerService,
    public dialog: MatDialog
  ) {
  }

  get frequencyThreshold(): number {
    if (!this.word) return 0;
    return this.synchronizerService.currentProject?.getFrequencyThreshold(this.word.reference.canon) || 50;
  }

  layoutDirectionLtr(): boolean {
    return this.synchronizerService.currentProject?.layout_direction === "ltr";
  }

  showParsing() {
    this.dialog.open(ParsingSummaryComponent, {
      width: '400px',
      data: { word: this.word }
    });
  }

}
